import * as XLSX from "xlsx";

/**
 * Descarga un archivo .xlsx con una o varias hojas tipadas.
 * @param {string} filename - nombre del archivo (incluye .xlsx)
 * @param {Array<{name: string, rows: Array<Array>, cols?: Array}>} sheets
 *   rows[0] suele ser el encabezado. Los valores numéricos deben ir como
 *   números JS para que Excel los tipe como número.
 */
export function downloadXlsx(filename, sheets) {
  const wb = XLSX.utils.book_new();
  sheets.forEach(({ name, rows, cols }) => {
    const ws = XLSX.utils.aoa_to_sheet(rows);
    if (cols) ws["!cols"] = cols;
    XLSX.utils.book_append_sheet(wb, ws, (name || "Hoja").slice(0, 31));
  });
  XLSX.writeFile(wb, filename);
}

const pad = (n) => String(n).padStart(2, "0");

/** Sello de fecha YYYY-MM-DD para nombres de archivo. */
export function todayStamp() {
  const d = new Date();
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}
